<div class="story-footer" *ngIf="story">
  <div class="story-footer__links">

    <button role="button" class="story-footer__link" (click)="openStoriesOverviewByFilter()">Alle {{story.portrait}}s</button>

    <ng-container *ngIf="story.portrait === 'Lehrlingsportrait'">
      <button role="button" class="story-footer__link" (click)="openRelatedProfession()">Zu dem Berufsbild</button>
      <button role="button" class="story-footer__link" (click)="openTrainingCompaniesOverview()">Zu den Ausbildungsbetrieben</button>
      <button role="button" class="story-footer__link" (click)="openRelatedJobsOverview()">Zu den Jobangeboten</button>
    </ng-container>

    <ng-container *ngIf="story.portrait === 'Berufsportrait'">
      <button role="button" class="story-footer__link" (click)="openRelatedProfession()">Zu dem Berufsbild</button>
    </ng-container>

    <ng-container *ngIf="story.portrait === 'Schulportrait'">
      <button role="button" class="story-footer__link" (click)="openSchoolsOverview()">Zu der weiterführenden Schule</button>
    </ng-container>

  </div>
</div>
